<template>
  <v-menu
    ref="menu"
    v-model="menu"
    lazy
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template #activator="{ on }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        :disabled="disabled"
        :rules="rules"
        return-masked-value
        mask="##/##/####"
        ref="textfield"
        @blur="updateValues(dateFormatted)"
        @keyup.h="updateValues(dateFormatted, false)"
        :error-messages="errors.collect(errors_collect)"
        :data-vv-as="data_vv_as"
        v-validate="v_validate"
        min="minvalue"
        max="maxvalue"
        :name="name"
      >
        <template v-slot:append>
          <v-icon @click="openMenu()">event</v-icon>
        </template>
      </v-text-field>
    </template>

    <v-date-picker
      ref="teste"
      v-model="date"
      locale="pt-br"
      style="display: table-cell"
      :max="max"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  data() {
    return {
      menu: false,
      date: "",
      dateTime: "",
      dateFormatted: "",
      max: null,
      limitedYear: null,
    };
  },
  props: {
    value: {
      type: String,
    },
    label: {
      type: String,
      default: "",
    },
    errors_collect: {
      type: String,
      default: "data",
    },
    limitPreviousYears: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {},
    name: {
      type: String,
    },
    v_validate: {
      type: String,
    },
    data_vv_as: {
      type: String,
    },
    minvalue: {
      type: String,
    },
    maxvalue: {
      type: String,
    },
  },
  watch: {
    value(val) {
      this.syncDateFormatted(this.value);
    },
    date(val) {
      this.syncDateFormatted();
    },
  },
  mounted() {
    if (this.value) {
      this.dateTime = this.moment(this.value);
      this.date = this.moment(this.value).format("YYYY-MM-DD");
    } else if (this.v_validate && this.v_validate.includes("required")) {
      this.date = this.moment().subtract(1, "years").format("YYYY-MM-DD");
    }

    if (this.limitPreviousYears) {
      this.limitedYear = this.$auth.user().anobase.id_texto;
      this.max = `${this.limitedYear}-12-31`;
    }
  },
  methods: {
    openMenu(e) {
      this.updateValues(this.dateFormatted, false);

      this.menu = true;
    },
    updateValues(value, nullable = true) {
      this.dateTime = this.moment(value, "DD/MM/YYYY", true);

      let date;

      if (this.dateTime.isValid()) {
        date = this.dateTime.format("YYYY-MM-DD");
        if (this.limitPreviousYears && this.dateTime.isAfter(this.max)) {
          this.dateTime = this.moment();
          this.dateTime.set("year", this.limitedYear);

          date = this.dateTime.format("YYYY-MM-DD");
        }
      } else {
        if (this.dateFormatted === "" && nullable) {
          date = "";
        } else {
          this.dateTime = this.moment();
          this.dateTime.set("year", this.limitedYear);

          date = this.dateTime.format("YYYY-MM-DD");
        }
      }

      this.date = date;
      this.$emit("input", date);
      this.dateFormatted = this.dateTime.format("DD/MM/YYYY");
    },
    syncDateFormatted(value = `${this.date}`) {
      this.dateTime = this.moment(value);

      this.dateFormatted = this.dateTime.isValid() ? this.dateTime.format("DD/MM/YYYY") : "";

      this.updateValues(this.dateFormatted);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/shared/PDate.vue